module.exports = __webpack_public_path__ + "img/SkillSession.8b7e4a74.svg";